const ActionTypes = {
    LAYOUT_COLLAPSED: 'LAYOUT_COLLAPSED',
    CURRENT_ROUTE: 'CURRENT_ROUTE'
}

export default ActionTypes